module.exports = __webpack_public_path__ + "img/selenium-logo.723b93c5.png";